import { render, staticRenderFns } from "./admin-header.vue?vue&type=template&id=0a6124e4&scoped=true"
import script from "./admin-header.vue?vue&type=script&lang=js"
export * from "./admin-header.vue?vue&type=script&lang=js"
import style0 from "./admin-header.vue?vue&type=style&index=0&id=0a6124e4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a6124e4",
  null
  
)

export default component.exports